import { useEffect, useState } from "react";





function normalizeOrders(orders, isDescending = true) {
    const merged = [];

    orders?.forEach((o) => {
        const existing = merged.find((m) => m.price === o.price);
        if (existing) existing.quantity += o.quantity;
        else merged.push({ ...o });
    });

    merged.sort((a, b) =>
        isDescending ? b.price - a.price : a.price - b.price
    );

    const top = merged.slice(0, 20);

    let cumulative = 0;
    top.forEach((o) => (cumulative += o.quantity));

    return top.map((o, idx) => {
        const cum = top
            .slice(0, idx + 1)
            .reduce((sum, x) => sum + x.quantity, 0);

        return {
            ...o,
            total: cum,
            percentage: cumulative ? (cum / cumulative) * 100 : 0,
        };
    });
}

export function useBybitOrderBook(symbol) {
    const [orderBook, setOrderBook] = useState({
        bids: [],
        asks: [],
        symbol: "",
    });

    useEffect(() => {
        if (!symbol) return;

        let ws;
        let book = { bids: [], asks: [] };

        // 1️⃣ SNAPSHOT
        fetch(`https://api.bybit.com/v5/market/orderbook?category=linear&symbol=${symbol}`)
            .then(res => res.json())
            .then(res => {
                const bids = res?.result?.b?.map(([p, q]) => ({
                    price: +p,
                    quantity: +q,
                })) || [];

                const asks = res?.result?.a?.map(([p, q]) => ({
                    price: +p,
                    quantity: +q,
                })) || [];

                book.bids = bids;
                book.asks = asks;

                setOrderBook({
                    bids: normalizeOrders(bids, true),
                    asks: normalizeOrders(asks, false),
                    symbol,
                });
            });

        // 2️⃣ WS
        ws = new WebSocket("wss://stream.bybit.com/v5/public/linear");

        ws.onopen = () => {
            ws.send(JSON.stringify({
                op: "subscribe",
                args: [`orderbook.50.${symbol}`],
            }));
        };

        ws.onmessage = (e) => {
            const msg = JSON.parse(e.data);
            if (!msg?.data) return;

            book.bids = msg.data.b.map(([p, q]) => ({ price: +p, quantity: +q }));
            book.asks = msg.data.a.map(([p, q]) => ({ price: +p, quantity: +q }));

            setOrderBook({
                bids: normalizeOrders(book.bids, true),
                asks: normalizeOrders(book.asks, false),
                symbol,
            });
        };

        return () => ws?.close();
    }, [symbol]);

    return orderBook;
}
